import React from 'react';

import { Button, Icon } from '@digital/ui';
import { Tooltip, message } from 'antd';
import api from '@app/api/api';


interface IUploadProps {
  idDoComponente: string;
  id: string;
  enderecoApi: string;
  nomeIdFormulario: string;
  iconName: React.ComponentProps<typeof Icon>['name'];
  hasFile: boolean;
  label?: string | undefined;
  buttonClass?: string | undefined;
  retorno: (data: any) => void;
  disabled?: boolean;
  type?: "default" | "primary" | "ghost" | "dashed" | "danger" | "link";
  accept?: string;
}

export const UploadComponent = (
  { id,
    enderecoApi,
    retorno,
    idDoComponente,
    nomeIdFormulario,
    iconName,
    hasFile,
    label,
    buttonClass,
    disabled,
    type = 'link',
    accept,
  }: IUploadProps) => {

  const teveMudanca = () => {
    const elemento = document.getElementById(`mrn-input-upload-${idDoComponente}`) as any;
    if (elemento) {
      const curFiles = elemento.files;

      if (accept) {
        const acceptedExtensions = accept.split(',').map(ext => ext.trim().toLowerCase());
        for (let i = 0; i < curFiles.length; i++) {
          const fileName = curFiles[i].name as string;
          const dotIndex = fileName.lastIndexOf('.');
          const fileExt = dotIndex >= 0 ? fileName.substring(dotIndex).toLowerCase() : '';
          if (!acceptedExtensions.includes(fileExt)) {
            message.error(`Somente arquivos ${acceptedExtensions.join(', ').toUpperCase()} são permitidos.`);
            elemento.value = '';
            return;
          }
        }
      }

      const form = new FormData();
      form.append(nomeIdFormulario, id);
      for (let i = 0; i < curFiles.length; i++) {
        form.append(`files`, curFiles[i]);
      }
      api
        .post(enderecoApi, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(data => {
          elemento.value = '';
          retorno(data);
        });
    }
  };

  const triggerMudanca = () => {
    const elemento = document.getElementById(`mrn-input-upload-${idDoComponente}`);
    if (elemento) {
      elemento.click();
    }
  };

  return (
    <>
      <Tooltip title="Adicionar Arquivo">
        <input
          id={`mrn-input-upload-${idDoComponente}`}
          type="file"
          onChange={teveMudanca}
          className="custom-input-type-file"
          style={{ cursor: 'pointer !important', display: 'none' }}
          multiple={true}
          accept={accept}
        />
        <Button
          id={`mrn-button-upload-${idDoComponente}`}
          icon={iconName}
          onClick={() => triggerMudanca()}
          className={(hasFile ? 'has-comments ' : '') + buttonClass}
          title={label}
          disabled={disabled}
          type={type}
        />
      </Tooltip>
    </>
  );
};
